import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import FormPrompt from "../DailogBoxes/formprompt";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ConfirmDialogBox from "../DailogBoxes/confirmdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";
import AddService from "./addsubcategory";
import { setsubcategory } from "../../actions/setsubcategoryaction";
import { isVendorRole, getVendorId } from "../../utils/rbac";
import "./subcategorylist.css";

const SubCategoryList = (props) => {
  const history = useHistory();
  const vendorLocked = isVendorRole();
  const lockedVendorId = vendorLocked ? getVendorId() : "";
  const [searchText, setsSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openFormDailog, setOpenFormDailog] = useState(false);
  const [openAlertDailog, setOpenAlertDailog] = useState(false);
  const [openErrorDailog, setOpenErrorDailog] = useState(false);
  const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
  const [allServicesList, setAllServicesList] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedVendorFilter, setSelectedVendorFilter] = useState(lockedVendorId);
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
  const [selectedGenderFilter, setSelectedGenderFilter] = useState("");
  const [selectedServiceName, setSelectedServiceName] = useState("");
  const [selectedServiceId, setSelectedServiceId] = useState("");

  useEffect(() => {
    onFetchAll();
  }, []);

  const onFetchAll = async () => {
    setIsLoading(true);
    const [fetchedServices, fetchedVendors, fetchedCategories] = await Promise.all([
      Service.getAllData("services"),
      Service.getAllData("vendors"),
      Service.getAllData("category"),
    ]);
    // For vendor roles: pre-filter to their own services only
    const filteredServices = vendorLocked
      ? fetchedServices.filter((s) => s.vendorId === lockedVendorId)
      : fetchedServices;
    setAllServicesList(filteredServices);
    setServicesList(filteredServices);
    setVendorList(fetchedVendors);
    setCategoryList(fetchedCategories);
    setIsLoading(false);
  };

  // Apply filters whenever filter state changes
  useEffect(() => {
    let filtered = [...allServicesList];
    if (selectedVendorFilter) {
      filtered = filtered.filter((s) => s.vendorId === selectedVendorFilter);
    }
    if (selectedCategoryFilter) {
      filtered = filtered.filter((s) => s.categoryId === selectedCategoryFilter);
    }
    if (selectedGenderFilter) {
      filtered = filtered.filter((s) => s.gender === selectedGenderFilter);
    }
    if (searchText) {
      const lower = searchText.toLowerCase();
      filtered = filtered.filter((s) =>
        (s.serviceName || "").toLowerCase().includes(lower)
      );
    }
    setServicesList(filtered);
  }, [selectedVendorFilter, selectedCategoryFilter, selectedGenderFilter, searchText, allServicesList]);

  const getVendorByUid = (vendorId) => vendorList.find((v) => v.uid === vendorId);

  const getVendorCodeById = (vendorId) => {
    const vendor = getVendorByUid(vendorId);
    return vendor?.vendorCode || "N/A";
  };

  const getSelectedVendorCode = () => {
    if (!selectedVendorFilter) return "";
    const vendor = getVendorByUid(selectedVendorFilter);
    return vendor?.vendorCode || "";
  };

  const handleOnEdit = (service) => {
    props.setOnsubcategory(service);
    history.push("/editsubcategory");
  };

  const handleOnDelete = (serviceName, id) => {
    setSelectedServiceName(serviceName);
    setSelectedServiceId(id);
    setOpenConfirmDailog(true);
  };

  const handleToggleActive = async (serviceId, currentStatus) => {
    const newStatus = !currentStatus;
    const res = await Service.updateData({ isActive: newStatus }, "services", serviceId);
    if (res === "success") {
      setAllServicesList((prev) =>
        prev.map((s) => (s.serviceId === serviceId ? { ...s, isActive: newStatus } : s))
      );
    }
  };

  const deleteData = async () => {
    setIsDeleting(true);
    const res = await Service.deleteData("services", selectedServiceId);
    if (res === "success") {
      setIsDeleting(false);
      setOpenConfirmDailog(false);
      setAllServicesList((prev) => prev.filter((s) => s.serviceId !== selectedServiceId));
    } else {
      setIsDeleting(false);
      handleErrorDailog();
    }
  };

  const handleSuccessDailog = () => {
    setOpenFormDailog(false);
    setOpenAlertDailog(true);
    onFetchAll(); // refresh list after add
  };
  const handleErrorDailog = () => {
    setOpenFormDailog(false);
    setOpenConfirmDailog(false);
    setOpenErrorDailog(true);
  };
  const closeFormDailog = () => setOpenFormDailog(false);
  const closeAlertDailog = () => {
    setOpenAlertDailog(false);
  };
  const closeErrorDailog = () => setOpenErrorDailog(false);
  const closeConfirmDailog = () => setOpenConfirmDailog(false);

  const clearFilters = () => {
    setSelectedVendorFilter("");
    setSelectedCategoryFilter("");
    setSelectedGenderFilter("");
    setsSearchText("");
  };

  let count = 0;

  return isLoading ? (
    <div className="subcategorylistpage">
      <i className="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
  ) : (
    <div className="subcategorylistpage">
      <div className="main_section">
        <ConfirmDialogBox
          openDailog={openConfirmDailog}
          onSetOpenDailog={closeConfirmDailog}
          handleConfirmOkBtn={deleteData}
          isLoading={isDeleting}
          title="Delete"
          des={`Are you sure to delete ${selectedServiceName} details`}
        ></ConfirmDialogBox>
        <AlertDialogBox
          openDailog={openAlertDailog}
          onSetOpenDailog={closeAlertDailog}
          title="Added"
          des="New Service has been added successfully"
        ></AlertDialogBox>
        <ErorrDialogBox
          openDailog={openErrorDailog}
          onSetOpenDailog={closeErrorDailog}
          title="Error"
          des="Something went wrong. Try again"
        ></ErorrDialogBox>

        <FormPrompt
          openDailog={openFormDailog}
          title="Add New Service"
          onSetOpenDailog={closeFormDailog}
        >
          <AddService
            handleSuccessDailog={handleSuccessDailog}
            handleErrorDailog={handleErrorDailog}
            defaultVendorCode={getSelectedVendorCode()}
            lockedVendorId={vendorLocked ? lockedVendorId : null}
          ></AddService>
        </FormPrompt>

        <div className="topheader">
          <ul>
            <li>
              <i className="fa fa-arrow-circle-o-right fa-2x" aria-hidden="true"></i>
            </li>
            <li>
              <h5>Services</h5>
            </li>
          </ul>
        </div>
        <hr />

        {/* Filter bar */}
        <div
          style={{
            background: "#f8f9fa",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "16px",
          }}
        >
          <div className="form-row align-items-end">
            {!vendorLocked && (
            <div className="col-md-3 mb-2">
              <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>
                Filter by Vendor
              </label>
              <select
                className="form-control form-control-sm"
                value={selectedVendorFilter}
                onChange={(e) => setSelectedVendorFilter(e.target.value)}
              >
                <option value="">All Vendors</option>
                {vendorList.map((v) => (
                  <option key={v.uid} value={v.uid}>
                    {v.vendorCode} — {v.name || v.businessName || v.uid}
                  </option>
                ))}
              </select>
            </div>
            )}
            <div className="col-md-2 mb-2">
              <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>
                Filter by Category
              </label>
              <select
                className="form-control form-control-sm"
                value={selectedCategoryFilter}
                onChange={(e) => setSelectedCategoryFilter(e.target.value)}
              >
                <option value="">All Categories</option>
                {categoryList.map((c) => (
                  <option key={c.categoryId} value={c.categoryId}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2 mb-2">
              <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>
                Filter by Gender
              </label>
              <select
                className="form-control form-control-sm"
                value={selectedGenderFilter}
                onChange={(e) => setSelectedGenderFilter(e.target.value)}
              >
                <option value="">All Genders</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="unisex">Unisex</option>
              </select>
            </div>
            <div className="col-md-3 mb-2">
              <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>
                Search by Name
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search service..."
                value={searchText}
                onChange={(e) => setsSearchText(e.target.value)}
              />
            </div>
            <div className="col-md-2 mb-2" style={{ display: "flex", gap: "8px" }}>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={clearFilters}
              >
                Clear
              </button>
              <span
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  alignSelf: "center",
                  whiteSpace: "nowrap",
                }}
              >
                {servicesList.length} result{servicesList.length !== 1 ? "s" : ""}
              </span>
            </div>
          </div>

          {selectedVendorFilter && (
            <div style={{ marginTop: "6px", fontSize: "13px", color: "#495057" }}>
              <strong>Vendor:</strong>{" "}
              {(() => {
                const v = getVendorByUid(selectedVendorFilter);
                return v ? `${v.vendorCode} — ${v.name || v.businessName || ""}` : "";
              })()}
              <span style={{ marginLeft: "12px", color: "#007bff" }}>
                {servicesList.length} services
              </span>
            </div>
          )}
        </div>

        <div className="top_section" style={{ marginBottom: "12px" }}>
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => setOpenFormDailog(true)}
          >
            + Add Service{vendorLocked ? " for Your Salon" : selectedVendorFilter ? ` for ${getSelectedVendorCode()}` : ""}
          </button>
        </div>

        <table className="table table-striped table-sm">
          <thead className="thead tablehead">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Image</th>
              <th scope="col">Service Name</th>
              <th scope="col">Category</th>
              <th scope="col">Group</th>
              <th scope="col">Gender</th>
              <th scope="col">Vendor</th>
              <th scope="col">Price</th>
              <th scope="col">Offer</th>
              <th scope="col">Min</th>
              <th scope="col">Active</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          {servicesList.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan="12" className="text-center text-muted" style={{ padding: "20px" }}>
                  No services found
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody className="tablebody">
              {servicesList.map((p) => {
                count++;
                return (
                  <tr key={p.serviceId}>
                    <td className="align-middle">{count}</td>
                    <td className="align-middle">
                      {p.image ? (
                        <img className="image" alt="" srcSet={p.image} />
                      ) : (
                        <div className="userbg">
                          <i className="fa fa-image fa-2x"></i>
                        </div>
                      )}
                    </td>
                    <td className="align-middle">{p.serviceName}</td>
                    <td className="align-middle" style={{ fontSize: "12px" }}>
                      {p.categoryName || p.categoryId}
                    </td>
                    <td className="align-middle" style={{ fontSize: "12px" }}>
                      {p.group || "—"}
                    </td>
                    <td className="align-middle">
                      <span
                        style={{
                          fontSize: "11px",
                          padding: "2px 6px",
                          borderRadius: "10px",
                          background:
                            p.gender === "male"
                              ? "#cce5ff"
                              : p.gender === "female"
                              ? "#f8d7da"
                              : "#d4edda",
                          color:
                            p.gender === "male"
                              ? "#004085"
                              : p.gender === "female"
                              ? "#721c24"
                              : "#155724",
                        }}
                      >
                        {p.gender || "—"}
                      </span>
                    </td>
                    <td
                      className="align-middle"
                      style={{ fontWeight: "bold", color: "#007bff", fontSize: "12px" }}
                    >
                      {getVendorCodeById(p.vendorId)}
                    </td>
                    <td className="align-middle">₹{p.actualPrice}</td>
                    <td className="align-middle">₹{p.offerPrice}</td>
                    <td className="align-middle">{p.serviceTime}</td>
                    <td className="align-middle">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={p.isActive !== false}
                          onChange={() =>
                            handleToggleActive(p.serviceId, p.isActive !== false)
                          }
                        />
                      </div>
                    </td>
                    <td className="align-middle">
                      <button
                        type="button"
                        className="btn btn-sm btn-success"
                        style={{ marginRight: "4px" }}
                        onClick={() => handleOnEdit(p)}
                      >
                        <i className="fa fa-edit" aria-hidden="true"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={() => handleOnDelete(p.serviceName, p.serviceId)}
                      >
                        <i className="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

const mapDisptachToProps = (dispatch) => {
  return {
    setOnsubcategory: (p) => {
      dispatch(setsubcategory(p));
    },
  };
};

export default connect(null, mapDisptachToProps)(SubCategoryList);
